import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _RawContentGetter = Getter.of();
export const _RawContentResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _RawContentResponse2RawContent = _Response2ResponseData();
export const _RawContent2Data = Fold.compose(_RawContentGetter, Res._Response());
export const _RawContent2Attributes = Fold.compose(_RawContent2Data, Lens.prop("attributes"));
export const _RawContentAttributes2Name = Fold.compose(_RawContent2Attributes, Lens.prop("name"));
export const _RawContentAttributes2Alias = Fold.compose(_RawContent2Attributes, Lens.prop("alias"));
export const _RawContentAttributes2Published = Fold.compose(_RawContent2Attributes, Lens.prop("published"));
export const _RawContentAttributes2State = Fold.compose(_RawContent2Attributes, Lens.prop("state"));
export const _RawContentAttributes2Content = Fold.compose(_RawContent2Attributes, Lens.prop("content"));

